export default "__VITE_ASSET__DR2Xr0I___"